import React, { useEffect, useState, useCallback } from "react";
import Favourite, { BookMarkItem } from "../components/Favourite";
import FavouriteSkeleton from "../components/FavouriteSkeleton";
import { bookMarks as fetchBookmarks, deletBookMarks, removeCourseBookMarks } from "../services/UserService";
// @ts-ignore
import ApiNames from "../constants/ApiNames";
import { useSearchParams } from "react-router-dom";
// @ts-ignore
import UserContext from "../utils/UserContext";
// @ts-ignore
import { NavigateNullMsisdn, getDataFromCookies } from "../utils/CommonFunction";

export interface FavouriteScreenProps {
  token?: string;
  loaderStatus: (status: boolean) => void;
}

const FavouriteScreen: React.FC<FavouriteScreenProps> = (props) => {

  const [title] = useState<string>("Favourites");
  const [bookMarks, setBookMarks] = useState<BookMarkItem[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [searchParams] = useSearchParams();
  
  const utm_source = searchParams.get("utm_source") || "";
  const { cookieMsisdn, cookieSubscribeId } = getDataFromCookies();

  const allBookmarks = useCallback(async () => {
    try {
      setIsLoading(true);
      const subscriber_id = cookieSubscribeId;
      const data = await fetchBookmarks(props.token);
      
      if (data && data.status === 200) {
        setBookMarks((data.response || []).map((item: any) => ({ ...item, id: String(item.id) })));
      } else if (data && data.status === 404) {
        setBookMarks([]);
      }
    } catch (err) {
      setBookMarks([]);
    } finally {
      setIsLoading(false);
      props.loaderStatus(true);
    }
  }, [cookieSubscribeId, props.token, props.loaderStatus]);

  const removeCollarBookMark = useCallback(async (videoId: string) => {
    const formdata = new FormData();
    formdata.append("subscriber_id", cookieSubscribeId);
    formdata.append("collar_video_id", videoId);
    const data = await deletBookMarks(formdata, props.token);
    return data && data.status === 200;
  }, [cookieSubscribeId, props.token]);

  const removeCourseBookMark = useCallback(async (
    bookmarkUrl: string | null = null,
    bookmarkId: string | null = null
  ) => {
    const formdata = new FormData();
    const url = bookmarkUrl ? bookmarkUrl : "";
    const id = bookmarkId ? bookmarkId : "";
    formdata.append("msisdn", cookieMsisdn);
    formdata.append("bookmarkUrl", url);
    formdata.append("id", id);
    const data = await removeCourseBookMarks(formdata, props.token);
    return data;
  }, [cookieMsisdn, props.token]);

  const removeBookMark = useCallback(async (item: BookMarkItem) => {
    if (item.isCollar && item.videoId) {
      const data = await removeCollarBookMark(item.videoId);
      if (data) {
        allBookmarks();
      }
    } else if (item.id) {
      const data = await removeCourseBookMark(null, item.id);
      if (data) {
        allBookmarks();
      }
    }
  }, [removeCollarBookMark, removeCourseBookMark, allBookmarks]);

  useEffect(() => {
    NavigateNullMsisdn();
    document.title = title;
    if (props.token !== null) {
      allBookmarks();
    } else {
      setIsLoading(false);
      props.loaderStatus(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, props.token, allBookmarks]);

  if (isLoading) {
    return <FavouriteSkeleton />;
  }

  return (
    <Favourite
      bookMarks={bookMarks}
      removeBookMark={removeBookMark}
      utm_source={utm_source}
    />
  );
};

export default FavouriteScreen;
